import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Dotação Orçamentária do Projeto",
  path: "/prestacaocontas/pcoprojeto/:pcoProjetoId/dotacaoorcamentaria",
  parent: "pcoprojeto",
  name: "pcoprojeto_dotacaoorcamentaria",
  component: () => import("@/views/prestacaocontas/pcodotacaoorcamentaria/CadastroComGrid.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: false,
 },
]
